import type { Logger } from '@wix/thunderbolt-becky-types'

export type BuilderAppVersion = {
	appId: string
	version: string
	overrideId?: string
	rollout?: boolean
	draft?: boolean
	dev?: boolean
}
export type BuilderAppVersions = Array<BuilderAppVersion>

export const BUILDER_APP_SEPARATOR = ','
export const BUILDER_APP_VERSION_SEPARATOR = ':'
export const BUILDER_APP_VERSION_OVERRIDE_SEPARATOR = '_'

export const deStringifyBuilderApps = (builderAppVersions?: string, logger?: Logger): BuilderAppVersions => {
	if (!builderAppVersions) {
		return []
	}

	return builderAppVersions
		.split(BUILDER_APP_SEPARATOR)
		.map((exp) => {
			const [appId, version] = exp.split(BUILDER_APP_VERSION_SEPARATOR)
			if (!version) {
				logger?.warn(`Builder app version is missing for app ${appId}`)
				return
			}
			const [versionPart, maybeOverrideId] = version.split(BUILDER_APP_VERSION_OVERRIDE_SEPARATOR)
			return {
				appId,
				version: versionPart.replace('^', ''),
				overrideId: maybeOverrideId,
				dev: version === 'dev',
				draft: version.endsWith('.0.0'), // x.0.0, no minor version
				rollout: maybeOverrideId === 'rollout',
			}
		})
		.filter((builderApp) => builderApp !== undefined) as BuilderAppVersions
}
